import { helperManager } from '../utils/Helper';
import { blockManager } from './blocks';
class FavoritesManager {
    constructor() {
        this.initFavoritesMenu();
        this.initFavoritesEdit();
    }
    onOrderUpdated(orderedIds) {
        const menuList = $('.js-Favorites .List');
        const items = menuList.find('.js-FavoritesItem');
        orderedIds.forEach((id) => {
            menuList.append(items.filter(`[data-id="${id}"]`));
        });
    }
    onItemDeleted(deletedId) {
        $(`.js-FavoritesItem[data-id="${deletedId}"]`).remove();
        this.itemsChanged();
    }
    onAddOrUpdated() {
        this.refreshFavoritesMenu();
        this.itemsChanged();
    }
    refreshFavoritesMenu() {
        const menuList = $('.js-Favorites .List');
        const currentItems = menuList.find('.js-FavoritesItem');
        const newItems = $('.js-Favorites .js-BlockEditableList .js-Item');
        const newHtml = [];
        newItems.toArray().forEach((favoriteElement) => {
            const favoriteData = $(favoriteElement).data('formdata');
            newHtml.push(this.getHtmlForFavorite(favoriteData));
        });
        currentItems.remove();
        newHtml.forEach((newMenuItem) => {
            menuList.append(newMenuItem);
        });
    }
    itemsChanged() {
        $('.js-Favorites .js-FavoritesToggleMoreBtn').toggleClass('Hidden', $('.js-Favorites .List').find('.js-FavoritesItem').length < 5);
    }
    getHtmlForFavorite(favorite) {
        favorite.isInternal = helperManager.isInternalWebsiteLink(favorite.url);
        const externalClass = 'Personal_MenuItem-External';
        const externalInsert = '<i class="RIcon-Arrow2UpRight MenuItem_Arrow-External"></i>';
        const template = `
                        <li class="Favorites_ListItem js-FavoritesItem" data-id="${favorite.id}">
                            <a class="Btn-Reset Btn Personal_MenuItem ${favorite.isInternal ? '' : externalClass}" href="${favorite.url}" tabindex="0">
                              ${favorite.isInternal ? '' : externalInsert}
                              ${favorite.title}
                            </a>
                        </li>`;
        return template;
    }
    initFavoritesMenu() {
        $(document).on('click', '.js-FavoritesToggleMoreBtn', () => {
            $('.js-Favorites').toggleClass('ShowAllItems');
        });
        this.itemsChanged();
    }
    initFavoritesEdit() {
        const favorites = $('.js-FavoritesEditable');
        if (favorites.length <= 0) {
            return;
        }
        const favoritesEditableBlock = blockManager.getBlock(favorites.get(0));
        favoritesEditableBlock.scrollBehaviour = false;
        favoritesEditableBlock.onOrderUpdated = (orderedIds) => {
            this.onOrderUpdated(orderedIds);
        };
        favoritesEditableBlock.onItemDeleted = (deletedId) => {
            this.onItemDeleted(deletedId);
        };
        favoritesEditableBlock.onAddOrUpdated = () => {
            this.onAddOrUpdated();
        };
    }
}
class Favorite {
    id;
    title;
    url;
    isInternal;
}
const favoritesManager = new FavoritesManager();
export { 
// types
FavoritesManager, Favorite, 
// global
favoritesManager };
